export default __webpack_public_path__ + "static/media/oval.1c42f98e.png";